module.exports = __webpack_public_path__ + "img/invite_bg01@3x.1a0b2171.png";